/**
 * @deprecated Do not use this for new functionality
 * It is better to use setTimeout with a recursive function
 * to avoid the possibility of multiple requests fired
 * before previous requests had the time to finish.
 * 
 * See: https://stackoverflow.com/a/8682723
 */
export default class AutoUpdateListTrigger {
    private _listUpdateIntervalInMs: number = 600000;
    private _interval: NodeJS.Timer;
    private _callback: () => void;

    constructor(callback: () => void, updateIntervallInMs: number = 600000) {
        this._callback = callback;
        this._listUpdateIntervalInMs = updateIntervallInMs;
    }

    subscribe() {
        if (!this._interval) {
            this._interval = setInterval(() => this._callback(), this._listUpdateIntervalInMs);
        }
    }

    unsubscribe() {
        clearInterval(this._interval);
        this._interval = null;
    }
}
